export default __webpack_public_path__ + "static/kioskBoothLeftRight-46329450185a7277a6d30f33eca00924.png";